import Close from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import React, { useMemo, useState } from "react";
import useLayanan from "../../services/queries/useLayanan";
import useUser from "../../services/queries/useUser";
import toRupiah from "../../utils/toRupiah";
import CardLangganan from "../CardLangganan/CardLangganan";

interface IModalPopupProps {
    dataUkm: {
        id: number;
        nama: string;
        trialFlag10: 0 | 1;
        trialTempo: string | null;
    };
    open: boolean;
    onClose: () => void;
}

const ModalPopup = ({ dataUkm, open, onClose }: IModalPopupProps) => {
    const moment = require("moment");
    const orderId = useMemo(() => moment().format("YYMMDDHHmmss"), [moment]);
    const { data: user } = useUser();

    const [selectedLayananId, setSelectedLayananId] = useState<number | null>(
        null,
    );

    const { data: dataLayanan } = useLayanan();

    const layanan1b = dataLayanan?.filter(
        (li) =>
            li.harga ===
            (process.env.NODE_ENV === "production" ? 70000 : 70000),
    )[0];
    const layanan3b = dataLayanan?.filter((li) => li.harga === 210000)[0];
    const layanan1t = dataLayanan?.filter((li) => li.harga === 600000)[0];

    return (
        <Dialog
            maxWidth="lg"
            // fullScreen={fullScreen}
            fullWidth={true}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: 4,
                },
            }}
            // sx={{
            //     "& .MuiDialog-container": {
            //         alignItems: "flex-start",
            //     },
            // }}
        >
            <DialogContent sx={{ padding: 0 }}>
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    justifyContent="flex-end"
                    padding={3}
                >
                    <IconButton onClick={onClose}>
                        <Close />
                    </IconButton>
                </Stack>

                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Typography
                        fontSize={20}
                        fontWeight={600}
                        textAlign="center"
                    >
                        Akun Anda Sedang Dalam Masa Trial
                    </Typography>

                    <Typography
                        fontSize={20}
                        textAlign="center"
                        width="80%"
                        justifyItems="center"
                        mt={2}
                    >
                        Masa uji coba anda masih berlangsung. Aktifkan versi
                        berbayar untuk terus menggunakan ULO. Pembayaran
                        tersedia via Virtual Account.
                    </Typography>
                </Stack>

                <Grid
                    container
                    alignItems="center"
                    justifyContent={"space-between"}
                    spacing={3}
                    p={4}
                >
                    <Grid item xs={12} sm={6} md={4}>
                        <CardLangganan
                            id={1}
                            harga={String(toRupiah(70000))}
                            click={() =>
                                setSelectedLayananId(Number(layanan1b?.id))
                            }
                            href={`/payment/U-${orderId}${user?.userId}/${selectedLayananId}/${dataUkm?.id}`}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CardLangganan
                            id={2}
                            harga={String(toRupiah(600000))}
                            hargaDis={String(toRupiah(960000))}
                            diskon="Diskon 37.5%"
                            click={() =>
                                setSelectedLayananId(Number(layanan1t?.id))
                            }
                            href={`/payment/U-${orderId}${user?.userId}/${selectedLayananId}/${dataUkm?.id}`}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CardLangganan
                            id={3}
                            harga={String(toRupiah(210000))}
                            hargaDis={String(toRupiah(240000))}
                            diskon="Diskon 12.5%"
                            click={() =>
                                setSelectedLayananId(Number(layanan3b?.id))
                            }
                            href={`/payment/U-${orderId}${user?.userId}/${selectedLayananId}/${dataUkm?.id}`}
                        />
                    </Grid>
                </Grid>

                <Stack
                    direction="row"
                    justifyItems="center"
                    justifyContent="center"
                    mt={3}
                    mb={4}
                >
                    <Typography>Butuh Bantuan?</Typography>

                    <Button
                        variant="text"
                        color="primary"
                        href="https://wa.me/6285757008008"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            padding: "0",
                            marginLeft: 1,
                            textTransform: "none",
                        }}
                    >
                        <Typography variant="body1">
                            Hubungi Customer Service
                        </Typography>
                    </Button>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};

export default ModalPopup;
